import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { PROCESS } from "@/data/content";

export default function Process() {
  return (
    <section id="process" className="py-24 lg:py-32 bg-[var(--dm-alt)] scroll-mt-20" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20">
          {/* sticky heading */}
          <div className="lg:sticky lg:top-28 self-start">
            <Reveal>
              <span className="overline text-[var(--dm-purple)]">Our Process</span>
              <h2 className="font-head font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900 mt-4 leading-[1.05]">
                A proven path from <span className="text-gradient">idea to impact</span>
              </h2>
              <p className="mt-6 text-lg text-slate-600 leading-relaxed">
                No guesswork. Every engagement follows a disciplined, transparent workflow designed to compound results at each stage.
              </p>
            </Reveal>
          </div>

          {/* manifesto chapters */}
          <div className="relative">
            <div className="absolute left-[27px] top-4 bottom-4 w-px bg-slate-200 hidden sm:block" />
            <div className="space-y-6">
              {PROCESS.map((p, i) => (
                <motion.div
                  key={p.no}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-70px" }}
                  transition={{ duration: 0.6, delay: i * 0.06 }}
                  className="relative flex gap-6 items-start group"
                  data-testid={`process-step-${i}`}
                >
                  <div className="relative z-10 shrink-0 w-14 h-14 rounded-2xl grid place-items-center font-head font-extrabold text-white text-lg group-hover:scale-105 transition-transform duration-300" style={{ background: "linear-gradient(135deg,#6C2BD9,#2563EB)" }}>
                    {p.no}
                  </div>
                  <div className="pt-1 rounded-2xl bg-white border border-slate-100 p-6 flex-1 group-hover:shadow-lg transition-shadow duration-300">
                    <h3 className="font-head font-bold text-xl text-slate-900 mb-1.5">{p.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{p.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
